import React, { memo, useState } from "react";
import { ReactSelect, SelectLabel, SelectWrapper } from "./style";
import { SelectT } from "./type";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ErrorLabelStyle } from "../input/style";
import { debounce } from "../../services/debounce";

const Index: React.FC<SelectT> = (props) => {
  const {
    labelClassName = "",
    label = "",
    control,
    name,
    options,
    error = false,
    change,
    isMulti = false,
    defaultValue,
    rules = { required: true },
    isClearable = true,
    isSearchable = false,
    placeholder = "form.select",
    className,
    isDisabled,
    onInputChange = () => {},
    onFocus,
    icon,
    getOptionLabel,
  } = props;

  const { t } = useTranslation();

  const handleInputChange = debounce(onInputChange, 400);

  const filterOption = (option: any) => {
    return option;
  };

  return (
    <SelectWrapper error={!!error} className={`mb-3 ${error ? "error" : ""}`}>
      <SelectLabel className={labelClassName}>
        {label} {icon ? <div className="info_icon">{icon}</div> : ""}{" "}
      </SelectLabel>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => (
          <ReactSelect
            classNamePrefix="react-select"
            placeholder={t(placeholder)}
            className={className}
            value={value}
            getOptionLabel={getOptionLabel}
            isClearable={isClearable}
            isSearchable={isSearchable}
            isMulti={isMulti}
            options={options}
            isDisabled={isDisabled}
            onFocus={onFocus}
            defaultValue={defaultValue}
            onInputChange={handleInputChange}
            filterOption={filterOption}
            onChange={(e: any) => {
              onChange(e);
              if (change) {
                change(e);
              }
            }}
          />
        )}
      />
      {!!error && (
        <ErrorLabelStyle>&nbsp;{t("GENERAL.MANDATORY_ROW")} !</ErrorLabelStyle>
      )}
    </SelectWrapper>
  );
};

export default memo(Index);
